import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGACY_TOKEN_KEY = "rangeo_token";

// Session lives only in the httpOnly cookie: no token in JS storage or in URLs
export const api = axios.create({ baseURL: API, withCredentials: true });
export const clearLegacyToken = () => localStorage.removeItem(LEGACY_TOKEN_KEY);

export const fileUrl = (path) => `${API}/files/${path}`;

export const errDetail = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "";
};

export async function resizeImage(file, max = 1280) {
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = URL.createObjectURL(file);
  });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.width * scale);
  canvas.height = Math.round(img.height * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  return new Promise((res) => canvas.toBlob((b) => res(b), "image/jpeg", 0.85));
}
